var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenDeskCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83058 1.83058C3.00269 0.65848 4.5924 0 6.25 0H43.75C45.4076 0 46.9973 0.65848 48.1694 1.83058C49.3415 3.00269 50 4.5924 50 6.25V35.4042C50 37.0618 49.3415 38.6515 48.1694 39.8236C46.9973 40.9957 45.4076 41.6542 43.75 41.6542H33.3292V45.8333H39.5792C40.1317 45.8333 40.6616 46.0528 41.0523 46.4435C41.443 46.8342 41.6625 47.3641 41.6625 47.9167C41.6625 48.4692 41.443 48.9991 41.0523 49.3898C40.6616 49.7805 40.1317 50 39.5792 50H10.3917C9.83913 50 9.30923 49.7805 8.91853 49.3898C8.52783 48.9991 8.30833 48.4692 8.30833 47.9167C8.30833 47.3641 8.52783 46.8342 8.91853 46.4435C9.30923 46.0528 9.83913 45.8333 10.3917 45.8333H16.6667V41.6542H6.25C4.5924 41.6542 3.00269 40.9957 1.83058 39.8236C0.65848 38.6515 0 37.0618 0 35.4042V6.25C0 4.5924 0.65848 3.00269 1.83058 1.83058ZM29.1667 45.8333V41.6542H29.1625H20.8292V45.8333H29.1667ZM24.5 34C26.433 34 28 32.433 28 30.5C28 28.567 26.433 27 24.5 27C22.567 27 21 28.567 21 30.5C21 32.433 22.567 34 24.5 34Z",
    fill: "#D75F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDeskCardIcon);
export default __webpack_public_path__ + "static/media/open-desk-card-icon.4812844d89e889ed763ed7510f67e606.svg";
export { ForwardRef as ReactComponent };